module.exports = __webpack_public_path__ + "img/20190819160619947.e68ce19e.png";